import { missionsApi } from '../../API/missionsConfig'
import { Summary } from './missionsTypes'

export const getMissions = async (signal?: AbortSignal): Promise<Summary> => {
    return await missionsApi
        .get('/summary', { signal })
        .then((response) => {
            return response.data
        })
        .then((data) => data)
        .catch((error) => {
            console.error('[] Error:', error)
            throw error
        })
}

export const claimMission = async (missionId: number): Promise<Summary['rewards'][0]> => {
    return await missionsApi
        .post(`/complete-mission`, {
            missionId,
        })
        .then((response) => {
            return response.data
        })
        .then((data) => data)
        .catch((error) => {
            console.error('[] Error:', error)
            throw error
        })
}

// All references should use missions terminology
